var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalmartIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walmart"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1736",
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Walmart Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2974",
    d: "M20.4255 15.842C21.022 15.842 21.5129 15.5318 21.5791 15.1312L22.1684 8.4715C22.1684 7.81311 21.3978 7.27271 20.4277 7.27271C19.459 7.27271 18.6892 7.81311 18.6892 8.4715L19.277 15.1312C19.3425 15.5318 19.8334 15.842 20.4277 15.842H20.4255Z",
    fill: "#FDBB30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2976",
    d: "M16.8269 17.9221C17.1263 17.4064 17.103 16.826 16.7884 16.5689L11.3144 12.7292C10.7455 12.4 9.89196 12.797 9.40763 13.6367C8.92184 14.475 9.00779 15.4123 9.57586 15.7415L15.6361 18.5637C16.0156 18.7043 16.532 18.4341 16.8291 17.9185L16.8269 17.9221Z",
    fill: "#FDBB30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2978",
    d: "M24.0288 17.9185C24.3274 18.4341 24.8416 18.7043 25.221 18.5637L31.282 15.7415C31.8531 15.4123 31.9346 14.475 31.4525 13.6367C30.966 12.797 30.1109 12.4 29.5436 12.7292L24.0696 16.5689C23.7564 16.826 23.7331 17.4065 24.031 17.9221L24.0288 17.9185Z",
    fill: "#FDBB30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2980",
    d: "M20.4255 24.1604C21.022 24.1604 21.5129 24.4685 21.5791 24.869L22.1684 31.528C22.1684 32.1879 21.3978 32.7275 20.4277 32.7275C19.459 32.7275 18.6892 32.1879 18.6892 31.528L19.277 24.869C19.3425 24.4685 19.8334 24.1604 20.4277 24.1604H20.4255Z",
    fill: "#FDBB30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2982",
    d: "M24.0288 22.0803C24.3274 21.5639 24.8416 21.2952 25.221 21.4379L31.282 24.2572C31.8531 24.5871 31.9346 25.5252 31.4525 26.365C30.966 27.2018 30.1109 27.5994 29.5436 27.271L24.0696 23.435C23.7564 23.1749 23.7331 22.5945 24.031 22.0796L24.0288 22.0803Z",
    fill: "#FDBB30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2984",
    d: "M16.8269 22.079C17.1263 22.5939 17.103 23.1744 16.7884 23.4344L11.3144 27.2704C10.7456 27.5989 9.89198 27.2012 9.40765 26.3644C8.92184 25.5246 9.00778 24.5866 9.57586 24.2566L15.6361 21.4373C16.0156 21.2946 16.532 21.5633 16.8291 22.0797L16.8269 22.079Z",
    fill: "#FDBB30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartIco);
export default __webpack_public_path__ + "static/media/walmartIco.9045f33d10ad64a23abead81c9c7c36d.svg";
export { ForwardRef as ReactComponent };